import { render } from "./LanguageSettings.vue?vue&type=template&id=8f80ff8c&scoped=true&ts=true"
import script from "./LanguageSettings.vue?vue&type=script&lang=ts"
export * from "./LanguageSettings.vue?vue&type=script&lang=ts"

import "./LanguageSettings.vue?vue&type=style&index=0&id=8f80ff8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f80ff8c"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QBtn});
